var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4418 12.9419C10.1977 13.186 9.80197 13.186 9.5579 12.9419L5.39123 8.77527C5.14715 8.5312 5.14715 8.13547 5.39123 7.89139C5.63531 7.64731 6.03103 7.64731 6.27511 7.89139L9.99984 11.6161L13.7246 7.89139C13.9686 7.64731 14.3644 7.64731 14.6084 7.89139C14.8525 8.13547 14.8525 8.5312 14.6084 8.77527L10.4418 12.9419Z",
    fill: "#4A4E5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/Icon-arrow-down.c4cbe2c5cea7c688a84ed5cba86a8030.svg";
export { ForwardRef as ReactComponent };